import React from "react";

interface NotificationIconProps {
  fill?: string;
}

const NotificationIcon: React.FC<NotificationIconProps> = ({
  fill = "currentColor",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9056 21.1521C12.1683 21.1522 12.4284 21.1005 12.6712 21C12.9139 20.8995 13.1344 20.7521 13.3202 20.5663C13.506 20.3806 13.6533 20.16 13.7538 19.9173C13.8543 19.6746 13.906 19.4144 13.906 19.1517L9.90446 19.151C9.90432 19.4139 9.95598 19.6741 10.0565 19.917C10.157 20.1598 10.3044 20.3805 10.4902 20.5663C10.6761 20.7522 10.8968 20.8996 11.1396 21.0001C11.3825 21.1006 11.6427 21.1523 11.9056 21.1521ZM6.74794 9.06909L6.74794 10.0944C6.74794 11.2003 6.46722 12.9391 6.11508 13.9955L5.04876 17.1959C4.8741 17.7212 5.18311 18.1561 5.74455 18.1561L17.8446 18.1561C18.406 18.1547 18.7178 17.7255 18.5396 17.1952L17.4747 13.9948C17.1254 12.9469 16.8426 11.2046 16.8419 10.0937L16.8412 9.06768C16.8412 7.9035 16.4389 6.77509 15.7023 5.87356C14.9657 4.97203 13.9402 4.3528 12.7994 4.12076C12.8145 3.98379 12.8014 3.84517 12.7609 3.71345C12.7205 3.58172 12.6535 3.45967 12.5641 3.3548C12.4747 3.24993 12.3648 3.16446 12.2411 3.10365C12.1175 3.04284 11.9827 3.00798 11.845 3.00122C11.7074 2.99445 11.5698 3.01592 11.4408 3.06431C11.3118 3.11269 11.194 3.18697 11.0948 3.28257C10.9955 3.37817 10.9169 3.49306 10.8637 3.62019C10.8105 3.74731 10.7839 3.88397 10.7855 4.02176C10.7869 4.0557 10.7876 4.08894 10.7919 4.12147C9.81992 4.31838 8.92759 4.79751 8.2265 5.49891C7.75708 5.9672 7.38476 6.52359 7.13091 7.13613C6.87706 7.74868 6.74738 8.40603 6.74794 9.06909Z"
      fill={fill}
    />
  </svg>
);

export default NotificationIcon;
